<script>
  import Icon from '../Icon';
  import { useSidebarOpen, useSidebarCurrentRoute } from './SidebarContext.svelte';

  export let name = undefined;
  export let icon;
  export let href;
  export let target = undefined;
  export let testid = undefined;

  const open = useSidebarOpen();
  const current = useSidebarCurrentRoute();

  $: active = name === $current;
</script>

<a {href} {target} class='sidebar-link' class:active class:open={$open} data-cy={testid}>
  <Icon {icon} />

  {#if $open}
    <div class='sidebar-link-text'>
      <slot/>
    </div>
  {/if}
</a>

<style lang="postcss">
  .sidebar-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing--s);
    color: var(--color--grey-80);
    text-decoration: none;
    padding: var(--spacing--xs);
    border-radius: var(--radius--s);
    font: var(--font--body-outfit-label);

    &.open {
      justify-content: start;
      width: 100%;
      box-sizing: border-box;
    }
    
    &.active {
      background: var(--color--accent);
      color: var(--color--white);
    }

    &:not(.active) {
      &:hover {
        background: var(--color--grey-10);
      }

      &:focus {
        background: var(--color--grey-20);
      }
    }
  }

  .sidebar-link-text {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
  }
</style>
